if (!customElements.get('lp-sub-switch-radio')) {
  class LpSubSwitchRadio extends HTMLElement {
    constructor() {
      super();
  
      this.sellingPlanId = this.getAttribute("data-sp-id");
      this.sellingPlanEl = this.querySelector('input[name="selling_plan"]');
      this.switchRadios = this.querySelectorAll(
        'input[name="lp_sub_switch_radio"]'
      );
      this.switchRadioActivate = this.querySelector(
        'input[name="lp_sub_switch_radio"][data-activate="true"]'
      );
  
      this.sellingPlanEl.value = this.isSubscription() ? this.sellingPlanId : "";
      this.updatePrices(this.isSubscription());
  
      this.switchRadios.forEach((switchRadio) =>
        switchRadio.addEventListener(
          "input",
          this.onActiveChangeHandler.bind(this)
        )
      );
    }
  
    onActiveChangeHandler(evt) {
      this.sellingPlanEl.value = this.isSubscription() ? this.sellingPlanId : "";
      this.updatePrices(this.isSubscription());
    }
  
    isSubscription() {
      return this.switchRadioActivate.checked;
    }
  
    updatePrices(isSubscription) {
      const oneTimePrices = document.querySelectorAll(
        '.variant-price:not([data-for="subscription"])'
      );
      const subscriptionPrices = document.querySelectorAll(
        '.variant-price[data-for="subscription"]'
      );
  
      oneTimePrices.forEach((el) => {
        if (isSubscription) {
          el.classList.add("hidden");
          return;
        }
        el.classList.remove("hidden");
      });
  
      subscriptionPrices.forEach((el) => {
        if (isSubscription) {
          el.classList.remove("hidden");
          return;
        }
        el.classList.add("hidden");
      });
    }
  }
  
  customElements.define("lp-sub-switch-radio", LpSubSwitchRadio);
}

if (!customElements.get('lp-sub-switch-checkbox')) {
  class LpSubSwitchCheckbox extends HTMLElement {
    constructor() {
      super();
  
      this.sellingPlanId = this.getAttribute("data-sp-id");
      this.sellingPlanEl = this.querySelector('input[name="selling_plan"]');
      this.switchCheckbox = this.querySelector(
        'input[name="lp_sub_switch_checkbox"]'
      );
  
      this.sellingPlanEl.value = this.isSubscription() ? this.sellingPlanId : "";
      this.updatePrices(this.isSubscription());
  
      this.switchCheckbox.addEventListener(
        "input",
        this.onActiveChangeHandler.bind(this)
      );
    }
  
    onActiveChangeHandler(evt) {
      this.sellingPlanEl.value = this.isSubscription() ? this.sellingPlanId : "";
      this.updatePrices(this.isSubscription());
    }
  
    isSubscription() {
      return this.switchCheckbox.checked;
    }
  
    updatePrices(isSubscription) {
      const oneTimePrices = document.querySelectorAll(
        '.variant-price:not([data-for="subscription"])'
      );
      const subscriptionPrices = document.querySelectorAll(
        '.variant-price[data-for="subscription"]'
      );
  
      oneTimePrices.forEach((el) => {
        if (isSubscription) {
          el.classList.add("hidden");
          return;
        }
        el.classList.remove("hidden");
      });
  
      subscriptionPrices.forEach((el) => {
        if (isSubscription) {
          el.classList.remove("hidden");
          return;
        }
        el.classList.add("hidden");
      });
    }
  }
  
  customElements.define("lp-sub-switch-checkbox", LpSubSwitchCheckbox);
}

if (!customElements.get('lp-card-buy-button')) {
  class LpCardBuyButton extends HTMLElement {
    constructor() {
      super();
      this.buttonEl = this.querySelector("button.lander-buy-now-button");
      this.variantId = this.buttonEl.getAttribute("data-v-id");
      this.sectionId = this.buttonEl.getAttribute("data-section-id");
  
      this.buttonEl.addEventListener("click", this.onClickHandler.bind(this));
    }
  
    onClickHandler(evt) {
      const buttons = document.querySelectorAll('button.lander-buy-now-button');
      buttons.forEach( el => el.disabled = true );
      
      const formEl = document.querySelector(
        'product-form[data-section-id="' + this.sectionId + '"]'
      );
  
      if(!formEl) {
        buttons.forEach( el => el.disabled = false );
        return
      }
  
      const formVariantIdInput = formEl.querySelector('input[name="id"]');
      formVariantIdInput.value = this.variantId;
  
      const formButton = formEl.querySelector('button[name="add"]');
      formButton.click();
    }
  }
  
  customElements.define("lp-card-buy-button", LpCardBuyButton);
}
